export const environment = {
  production: import.meta.env.NG_APP_ENV === 'production',
  graphql: import.meta.env.NG_APP_API_URL || '/graphql',
  isLocal: import.meta.env.NG_APP_ENV === 'local',
  googleMapsApiKey: import.meta.env.NG_APP_GOOGLE_MAPS_API_KEY || '',
};
